export const Symbols = {
    isEqualTo : '=',
    isGreaterThan: '>',
    isGreaterThanEqual: '>=',
    isLessThan: '<',
    isLessThanEqual: '<=',
    isNotEqualTo: '!='
}